import { currentPageContextReducer ,uiReducer, customerJourneyReducer } from "../reducers";
import { JStore } from "../journeys/context/interfaces";
import actionTypeConstants from "./actionTypeConstants";

export interface NewJStore {
    currentPageContextReducer: JStore,
    customerJourneyReducer:JStore

}

export function getInitialState() {
    const INIT_ACTION = {
        type: actionTypeConstants.INIT,
    }

    return {
        currentPageContext: currentPageContextReducer({} as JStore,INIT_ACTION),
        ui: uiReducer({} as JStore, INIT_ACTION),
        customerJourneyContext: customerJourneyReducer({} as JStore, INIT_ACTION)
    }
}